module.exports = __webpack_public_path__ + "static/media/orchestra_w_565.d9f6b920.jpg";